<section class="mx-auto flex h-full max-w-3xl flex-col items-center justify-center px-5 py-10 text-center">
  <div class="grid size-12 place-items-center rounded-xl border border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900 dark:bg-blue-950/60 dark:text-blue-300">
    <svg aria-hidden="true" viewBox="0 0 24 24" class="size-6" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="6" width="16" height="14" rx="4" /><path d="M9 11h.01M15 11h.01M9 16h6M12 3v3" /></svg>
  </div>
  <h2 class="mt-5 text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">{{ 'emptyState.title' | transloco }}</h2>
  <p class="mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">{{ 'emptyState.description' | transloco }}</p>

  @if (showQuestionSuggestions) {
    <div class="mt-8 grid w-full gap-3 sm:grid-cols-2">
      @for (suggestion of suggestions; track suggestion) {
        <button
          type="button"
          class="border border-slate-200 bg-white px-4 py-3 text-left text-sm leading-5 text-slate-700 transition hover:border-blue-300 hover:bg-blue-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300 dark:hover:border-blue-800 dark:hover:bg-slate-800"
          (click)="selectSuggestion(suggestion)"
        >
          {{ suggestion | transloco }}
        </button>
      }
    </div>
  }
</section>
